import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { authToken } from '../../scripts/authentication.script';

export class VatReturnDA {
  static apiResponse: ApiResponse

  public static async getVatReturn(
    id_company: string,
    id_period: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/vat-return?id_period=${id_period}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async getVatReturnCase(
    id_company: string,
    case_code: string,
    id_period: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/vat-return/${case_code}?id_period=${id_period}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async listAdjustments(
    id_company: string,
    id_period: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/vat-return/adjustments?id_period=${id_period}`
    let config: any = { headers: { Authorization: authToken() } }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async upsertAdjustment(
    id_company: string,
    id_period: string,
    case_code: string,
    amount: number,
    note?: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/vat-return/adjustments?id_period=${id_period}`
    let config: any = { headers: { Authorization: authToken() } }
    let body: any = { case_code, amount }
    if (note !== undefined) body.note = note

    await axios.put(url, body, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async attachAdjustmentVoucher(
    id_company: string,
    id_period: string,
    case_code: string,
    file: File
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/vat-return/adjustments/${case_code}/vouchers?id_period=${id_period}`

    const formData = new FormData()
    formData.append('file', file)

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, formData, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async getAdjustmentVoucherUrl(
    id_company: string,
    id_period: string,
    case_code: string,
    index: number
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/vat-return/adjustments/${case_code}/vouchers/${index}/url?id_period=${id_period}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async deleteAdjustmentVoucher(
    id_company: string,
    id_period: string,
    case_code: string,
    index: number
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/vat-return/adjustments/${case_code}/vouchers/${index}?id_period=${id_period}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.delete(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async attachAdjustmentExistingDocument(
    id_company: string,
    id_period: string,
    case_code: string,
    id_document_inbox: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/vat-return/adjustments/${case_code}/vouchers?id_period=${id_period}`
    let config: any = { headers: { Authorization: authToken() } }
    let body = { id_document_inbox }

    await axios.post(url, body, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async deleteAdjustment(
    id_company: string,
    id_period: string,
    case_code: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/vat-return/adjustments/${case_code}?id_period=${id_period}`
    let config: any = { headers: { Authorization: authToken() } }

    await axios.delete(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }
}
